import {
  UseMutationResult,
  useMutation,
  useQueryClient
} from '@tanstack/react-query'
import { graphql } from 'ms-client/graphql/user-pool'
import {
  getCurrentUserByIdKey,
  getCurrentWorkspaceKey,
  useAuth
} from 'user-auth'
import {
  DeleteWorkspaceByIdMutation,
  DeleteWorkspaceByIdMutationVariables
} from '~workspace/types/__generated/gql/graphql'

const query = /* GraphQL */ `
  mutation DeleteWorkspaceById($id: ID!) {
    deleteWorkspaceById(id: $id) {
      id
      name
    }
  }
`

export type DeleteWorkspaceByIdResults =
  DeleteWorkspaceByIdMutation['deleteWorkspaceById']
export type DeleteWorkspaceByIdVariables = DeleteWorkspaceByIdMutationVariables

export const useDeleteWorkspaceById = (): UseMutationResult<
  DeleteWorkspaceByIdResults,
  Error,
  DeleteWorkspaceByIdVariables
> => {
  const { userId } = useAuth()
  const client = useQueryClient()

  return useMutation({
    mutationKey: ['deleteWorkspaceById'],
    mutationFn: async (variables: DeleteWorkspaceByIdVariables) => {
      const data = await graphql<
        DeleteWorkspaceByIdMutation,
        DeleteWorkspaceByIdVariables
      >({
        query,
        variables: variables
      })
      await client.invalidateQueries({
        queryKey: getCurrentUserByIdKey()
      })
      await client.invalidateQueries({
        queryKey: getCurrentWorkspaceKey(userId)
      })
      return data?.deleteWorkspaceById
    }
  })
}
